import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { authService } from '../../../services/AuthenticationService';
import { mapAuthError } from '../../../utils/auth-error';
import { routes } from '../../../route-list';
import { ForgotPasswordScreen } from '../components/ForgotPasswordScreen';

export const ForgotPasswordContainer: React.FC = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [socialProvider, setSocialProvider] = useState<'google' | 'apple' | null>(null);

  const onReset = async (email: string) => {
    setErrorMessage(null);
    setSocialProvider(null);
    setLoading(true);
    try {
      const method = await authService.getLoginMethod(email);
      if (method === 'google' || method === 'apple') {
        setSocialProvider(method);
        return;
      }
      await authService.resetPassword(email);
      setSent(true);
    } catch (e) {
      setErrorMessage(mapAuthError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <ForgotPasswordScreen
      loading={loading}
      errorMessage={errorMessage}
      sent={sent}
      socialProvider={socialProvider}
      onReset={onReset}
      onBackToLogin={() => history.push(routes.LOGIN)}
    />
  );
};
